import { render, staticRenderFns } from "./modal-remark.vue?vue&type=template&id=0f58643b&"
import script from "./modal-remark.vue?vue&type=script&lang=js&"
export * from "./modal-remark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports